import { createSlice, createSelector } from "@reduxjs/toolkit";
import { candidateApiSlice } from "./candidateApiSlice";
import config from "../../config.json";

const slice = createSlice({
  name: "candidates",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    filterList: [],
    reminder: "",
    apps: [],
    appAllTasks: [],
    appTasks: [],
    appDocuments: [],
    appDocusignDocs: [],
    backgroundChecks: [],
    appMessages: [],
    scheduleMeetings: [],
    appFormLibrary: [],
    meetingAcceptStatus: false,
    meetingLinkSendStatus: false,
    updDocDeleteStatus: false,
  },
  reducers: {
    candidateAdded: (candidates, action) => {
      candidates.list.push(action.payload);
    },
    candidatesReceived: (candidates, action) => {
      candidates.list = action.payload;
      candidates.reminder = "";
    },
    filterCandidatesReceived: (candidates, action) => {
      candidates.filterList = action.payload;
      candidates.reminder = "";
    },
    reminderSent: (candidates, action) => {
      candidates.reminder = action.payload;
    },
    candidateAppsReceiving: (candidates, action) => {
      candidates.apps = [];
    },
    candidateAppsReceived: (candidates, action) => {
      if (!action || !action?.payload) candidates.apps = [];
      else {
        const filterApp = action.payload?.filter(
          (x) => x.pmId !== config.WorkflowIds.SupportPmId
        );
        candidates.apps = filterApp;
      }
    },
    candidateAppAllTasksReceived: (candidates, action) => {
      candidates.appAllTasks = action.payload;
    },
    candidateParentAppsReceived: (candidates, action) => {
      candidates.parentApps = action.payload;
    },
    appTasksReceived: (candidates, action) => {
      candidates.appTasks = action.payload;
    },
    appDocumentReceived: (candidates, action) => {
      candidates.appDocuments = action.payload;
    },
    appDocusignDocsReceived: (candidates, action) => {
      candidates.appDocusignDocs = action.payload;
    },
    backgroundChecksReceived: (candidates, action) => {
      candidates.backgroundChecks = action.payload;
    },
    appMessagesRecevied: (candidates, action) => {
      candidates.appMessages = action.payload;
    },
    appFormLibraryRecevied: (candidates, action) => {
      candidates.appFormLibrary = action.payload;
    },
    meetingRecevied: (candidates, action) => {
      candidates.scheduleMeetings = action.payload;
      candidates.meetingAcceptStatus = false;
      candidates.meetingLinkSendStatus = false;
    },
    scheduleMeetingAccepted: (candidates, action) => {
      candidates.meetingAcceptStatus = action.payload;
    },
    scheduleMeetingLinkSent: (candidates, action) => {
      candidates.meetingLinkSendStatus = action.payload;
    },
    uploadedDocumentDeleted: (candidates, action) => {
      candidates.updDocDeleteStatus = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        candidateApiSlice.endpoints.sendReminder.matchFulfilled,
        (candidates, action) => {
          candidates.reminder = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadCandidatesByFilter.matchFulfilled,
        (candidates, action) => {
          candidates.filterList = action.payload;
          candidates.reminder = "";
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadCandidateApps.matchFulfilled,
        (candidates, action) => {
          if (!action || !action?.payload) candidates.apps = [];
          else {
            const filterApp = action.payload?.filter(
              (x) => x.pmId !== config.WorkflowIds.SupportPmId
            );
            candidates.apps = filterApp;
          }
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadCandidateAppAllTasks.matchFulfilled,
        (candidates, action) => {
          candidates.appAllTasks = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadAppRuningTasks.matchFulfilled,
        (candidates, action) => {
          candidates.appTasks = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadAppDocuments.matchFulfilled,
        (candidates, action) => {
          candidates.appDocuments = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadAppDocusignDocs.matchFulfilled,
        (candidates, action) => {
          candidates.appDocusignDocs = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadBackgroundChecks.matchFulfilled,
        (candidates, action) => {
          candidates.backgroundChecks = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadSheduleMeeting.matchFulfilled,
        (candidates, action) => {
          candidates.scheduleMeetings = action.payload;
          candidates.meetingAcceptStatus = false;
          candidates.meetingLinkSendStatus = false;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.acceptSheduleMeeting.matchFulfilled,
        (candidates, action) => {
          candidates.meetingAcceptStatus = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.sendSheduleMeetingLinks.matchFulfilled,
        (candidates, action) => {
          candidates.meetingLinkSendStatus = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadPortalAppMessages.matchFulfilled,
        (candidates, action) => {
          candidates.appMessages = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.loadAppFormLibrary.matchFulfilled,
        (candidates, action) => {
          candidates.appFormLibrary = action.payload;
        }
      )
      .addMatcher(
        candidateApiSlice.endpoints.deleteUploadedDocument.matchFulfilled,
        (candidates, action) => {
          candidates.updDocDeleteStatus = action.payload;
        }
      );
  },
});

export const {
  candidateAdded,
  candidatesReceived,
  filterCandidatesReceived,
  reminderSent,
  candidateAppsReceiving,
  candidateAppsReceived,
  candidateAppAllTasksReceived,
  candidateParentAppsReceived,
  appTasksReceived,
  appDocumentReceived,
  appDocusignDocsReceived,
  backgroundChecksReceived,
  appMessagesRecevied,
  meetingRecevied,
  appFormLibraryRecevied,
  scheduleMeetingAccepted,
  scheduleMeetingLinkSent,
  uploadedDocumentDeleted,
} = slice.actions;
export default slice.reducer;

export const SendReminder = (id) =>
  candidateApiSlice.endpoints.sendReminder.initiate(id);

export const loadCandidatesByFilter = (data) =>
  candidateApiSlice.endpoints.loadCandidatesByFilter.initiate(data);

export const loadCandidateApps = (id, options) =>
  candidateApiSlice.endpoints.loadCandidateApps.initiate(id, options);

export const loadCandidateAppAllTasks = (id, options) =>
  candidateApiSlice.endpoints.loadCandidateAppAllTasks.initiate(id, options);

export const loadAppRuningTasks = (wfId, userId, options) =>
  candidateApiSlice.endpoints.loadAppRuningTasks.initiate({ wfId, userId }, options);

export const loadAppDocuments = (wfId, userId, options) =>
  candidateApiSlice.endpoints.loadAppDocuments.initiate({ wfId, userId }, options);

export const loadAppDocusignDocs = (userId, options) =>
  candidateApiSlice.endpoints.loadAppDocusignDocs.initiate(userId, options);

export const loadBackgroundChecks = (userId, options) =>
  candidateApiSlice.endpoints.loadBackgroundChecks.initiate(userId, options);

export const loadSheduleMeeting = (userId, options) =>
  candidateApiSlice.endpoints.loadSheduleMeeting.initiate(userId, options);

export const acceptSheduleMeeting = (option) =>
  candidateApiSlice.endpoints.acceptSheduleMeeting.initiate(option);

export const sendSheduleMeetingLinks = (option) =>
  candidateApiSlice.endpoints.sendSheduleMeetingLinks.initiate(option);

export const loadAppMessages = (wfId, userId, options) =>
  candidateApiSlice.endpoints.loadPortalAppMessages.initiate({ wfId, userId }, options);

export const loadAppFormLibrary = (wfId, userId, options) =>
  candidateApiSlice.endpoints.loadAppFormLibrary.initiate({ wfId, userId }, options);

export const deleteUploadedDocument = (id, type) =>
  candidateApiSlice.endpoints.deleteUploadedDocument.initiate({ id, type });

export const getReminderStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.reminder
);

export const getFilterAllCandidates = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.filterList
);

export const getCandidateApps = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.apps
);
export const getCandidateAppAllTasks = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.appAllTasks
);

export const getAppTasks = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.appTasks
);

export const getAppDocuments = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.appDocuments
);
export const getAppFormLibrary = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.appFormLibrary
);

export const getAppDocusignDocs = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.appDocusignDocs
);

export const getBackgroundChecks = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.backgroundChecks
);

export const getAppMessages = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.appMessages
);

export const getAppScheduleMeetings = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.scheduleMeetings
);

export const getMeetingAcceptStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.meetingAcceptStatus
);
export const getUploadDocDeleteStatus = createSelector(
  (state) => state.entities.candidates,
  (candidates) => candidates.updDocDeleteStatus
);
